// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"388":"2190567f","393":"36eed8e3","496":"2190567f","686":"2190567f","792":"2190567f"}[chunkId] + ".chunk.css";
};